import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';
import { useCallback } from 'react';

type NavBehavior = 'show' | 'push';

type Params =
  | {
      dialogType: 'deposit' | 'withdraw';
      productId?: number;
      navBehavior?: NavBehavior;
    }
  | {
      dialogType:
        | 'repay'
        | 'borrow'
        | 'provide_liquidity'
        | 'withdraw_liquidity';
      productId: number;
      navBehavior?: NavBehavior;
    };

export function useShowDialogForProduct() {
  const { show, push } = useDialog();

  return useCallback(
    ({ dialogType, productId, navBehavior = 'show' }: Params) => {
      const navFn = navBehavior === 'push' ? push : show;

      switch (dialogType) {
        case 'provide_liquidity':
        case 'withdraw_liquidity':
          navFn({
            type: dialogType,
            params: {
              productId,
            },
          });
          break;
        case 'deposit':
          // Route to the new Nado deposit dialog (unified same-chain + cross-chain)
          navFn({
            type: 'nado_deposit',
            params: {},
          });
          break;
        case 'withdraw':
          // Route to the new Nado withdrawal dialog (unified same-chain + cross-chain)
          navFn({
            type: 'nado_withdraw',
            params: {},
          });
          break;
        case 'borrow':
        case 'repay':
          navFn({
            type: dialogType,
            params: {
              initialProductId: productId,
            },
          });
      }
    },
    [push, show],
  );
}
